module.exports = __webpack_public_path__ + "img/Kashiwagi.379e9b62.jpg";